/**
 * 软键盘弹起时，避免把可视区域高度同步为全局页面高度。
 */
export function shouldSyncViewportHeight(activeElement: Pick<HTMLElement, 'tagName'|'isContentEditable'> | null) {
  const tagName = activeElement?.tagName || '';
  return !activeElement?.isContentEditable && !['INPUT', 'TEXTAREA', 'SELECT'].includes(tagName);
}

/** 仅识别 Safari，排除各类应用内浏览器与其他 iOS 浏览器。 */
export function isSafariBrowser(userAgent: string) {
  return /Safari\//i.test(userAgent) && !/(CriOS|FxiOS|EdgiOS|OPiOS|Chrome|Chromium|MicroMessenger|wxwork|DingTalk|Lark|Feishu)/i.test(userAgent);
}
